module.exports = __webpack_public_path__ + "static/media/proj19_img10.b334b124.jpg";